import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Forside from './pages/Forside';
import YdelseDetalje from './pages/YdelseDetalje';
import OmOs from './pages/OmOs';
import Referencer from './pages/Referencer';
import Kontakt from './pages/Kontakt';
import Error403 from './pages/Error403';
import Error404 from './pages/Error404';

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-navy-50 text-brand-navy-900 antialiased">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Forside />} />
          <Route path="/ydelser/:slug" element={<YdelseDetalje />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/referencer" element={<Referencer />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* Error Pages */}
          <Route path="/403" element={<Error403 />} />
          <Route path="/404" element={<Error404 />} />

          {/* Fallback to 404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
